module.exports = __webpack_public_path__ + "img/magento.05d829a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/magento.png
// module id = hxe8
// module chunks = 38 43